import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../../../services/security/authentication.service';
import { RecordAction } from '../../../../../../utils/enums/shared/enums';
import { ProtocolService } from '../../../../../../services/protocol/protocol.service';
import { Protocol } from '../../../../../../utils/types/protocol/protocol.type';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-protocol-form",
    templateUrl: "./protocol-form.component.html",
    styleUrls: ["./protocol-form.component.scss"],
    providers: [ProtocolService, AuthenticationService],
    encapsulation: ViewEncapsulation.None,
})
export class ProtocolFormComponent implements OnInit {
    protocolModel: Protocol;
    dialogTitle: string;
    protocolForm: FormGroup;
    action: RecordAction;
    callback: (protocol) => void;

    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    constructor(
        public dialogRef: MatDialogRef<ProtocolFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: ProtocolService,
        private translateService: TranslateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");

        this.protocolModel = data.protocol;
        this.action = data.action;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = this.protocolModel.name;
        } else {
            this.dialogTitle = "Nuevo Protocolo";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.protocolModel = new Protocol();
        }

        this.protocolForm = this.createForm();
    }

    ngOnInit() {}

    createForm() {
        const form = new FormGroup({
            name: new FormControl(this.protocolModel.name, [
                Validators.required,
                Validators.pattern(
                    "^[a-zA-ZñÑÀ-ú0-9_]+( [a-zA-ZñÑÀ-ú0-9_]+)*$"
                ),
            ]),
            active: new FormControl(Boolean(this.protocolModel.active)),
        });

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.protocolModel.name = value)
        );
        form.controls["active"].valueChanges.subscribe(
            (value) => (this.protocolModel.active = value)
        );
        return form;
    }

    performAction() {
        if (this.protocolForm.invalid) {
            return;
        }

        this.callback(this.protocolModel);
    }
}
